import { MenuItem as MuiMenuItem, styled, MenuItemProps as MuiMenuItemProps } from '@mui/material';
import { PropsWithChildren } from 'react';
import { getDataIdGenerator } from '../../shared/utils/dataId';

interface MenuItemProps extends MuiMenuItemProps {
  dataId?: string;
}

const dataIdGenerator = getDataIdGenerator('menu-item');

export const MenuItem = styled(
  ({ dataId = '', children, ...props }: PropsWithChildren<MenuItemProps>) => (
    <MuiMenuItem disableRipple data-id={dataIdGenerator(dataId)} {...props}>
      {children}
    </MuiMenuItem>
  )
)(() => ({
  '&.MuiMenuItem-root': {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    padding: '12px 16px',
    color: 'var(--text-default-color)',
    textShadow: 'none',
    flexShrink: 0,
    fontWeight: 600,
    fontSize: '12px',
    lineHeight: '16px',
    fontFamily: 'var(--font-family) !important'
  },
  '&.Mui-selected:not(.Mui-disabled)': {
    background: 'var(--primary-faded-color)',
    position: 'relative',

    '&::after': {
      fontFamily: '"hevo-pack"',
      content: '"\\e989"',
      position: 'absolute',
      right: 'calc(var(--spacer) * 0.75)',
      color: 'var(--primary-color)'
    }
  },
  '&.MuiMenuItem-root:&:hover:not(.active):not(.Mui-disabled),&:focus:not(.active):not(.origin-mouse):not(.Mui-disabled)':
    {
      background: 'var(--hover-bg-color)'
    },
  '&.MuiMenuItem-root.warning': {
    color: 'var(--warning-color)'
  },
  '&.MuiMenuItem-root.error': {
    color: 'var(--error-color)'
  },
  '&.MuiMenuItem-root.has-separator': {
    borderTop: 'solid 1px var(--divider-color)'
  },
  '&.Mui-disabled': {
    color: 'var(--text-secondary-color)',
    opacity: 0.5
  },
  '&.MuiMenuItem-root .hevo-icon': {
    marginRight: 'var(--spacer-12)'
  }
}));
